import { GzAntimalwareOnAccessWebComponent } from './component/GzAntimalwareOnAccessWebComponent';

export { GzAntimalwareOnAccessWebComponent };
